/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./BaseListGroup.vue?vue&type=template&id=25bfdb82"
import script from "./BaseListGroup.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseListGroup.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./BaseListGroup.vue?vue&type=style&index=0&id=25bfdb82&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports